import useClassDetails from 'hooks/API/GET/useClassDetails';
import useQueryParams from 'hooks/useQueryParams';
import { memo } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { HiArrowSmRight } from 'react-icons/hi';
import Flag from './Flag';

function DetailsHeader({ fromAssess, fromPerform }) {
  const { classID, courseID, chapterID, topicID, quizID } = useParams();
  const queryParams = useQueryParams();
  const subtopicID = queryParams.get('subtopic');
  const previousPageTab = queryParams.get('screen');
  const paperId = queryParams.get('paperId');
  const topicId = queryParams.get('topicId');

  const { isLoading, data, isError } = useClassDetails({
    config: { params: { classID, courseID, chapterID, topicID, quizID, subtopicID } },
  });

  const result = data?.data;
  const {
    class: classDetail = {},
    course = {},
    chapter = {},
    topic = {},
    subtopic = {},
    quiz = {},
    est = {},
    es = {},
    stream = {},
  } = result || {};

  const courseQueryObj = {};
  if (previousPageTab) courseQueryObj.currentTab = `${previousPageTab}`.replace('screen_', '');
  if (topicId) courseQueryObj.highlightSection = topicId;
  if (subtopicID) courseQueryObj.highlightSection = subtopicID;
  if (paperId) courseQueryObj.highlightSection = paperId;

  const courseQueryString = new URLSearchParams(courseQueryObj).toString();

  return (
    <>
      {isLoading ? (
        'Loading...'
      ) : isError ? (
        'Failed to load details'
      ) : (
        <>
          <Stack spacing={2}>
            <Breadcrumbs separator={<HiArrowSmRight fontSize="small" />} aria-label="breadcrumb">
              {est?._id ? (
                <Flag id={est.key} name={est.name} />
              ) : course?.est?._id ? (
                <Flag id={course?.est.key} name={course?.est.name} />
              ) : null}
              {es?._id ? (
                <Link underline="none" key="1" color="inherit" href={`#`} role="button">
                  {es?.name}
                </Link>
              ) : course?.es?._id ? (
                <Link underline="none" key="1" color="inherit" href={`#`} role="button">
                  {course?.es?.name}
                </Link>
              ) : null}{' '}
              {stream?._id && (
                <Link underline="none" key="1" color="inherit" href={`#`} role="button">
                  {stream?.name}
                </Link>
              )}
              {course?._id && (
                <Link
                  underline="hover"
                  key="1"
                  color="inherit"
                  href={`/classes/${classID}/courses/${course?._id}/${
                    fromAssess ? 'assess' : fromPerform ? 'perform' : 'chapters'
                  }?${courseQueryString}`}
                >
                  {course?.name || course?.courseName}
                </Link>
              )}
              {chapter?._id && (
                <Link
                  underline="hover"
                  key="1"
                  color="inherit"
                  href={`/classes/${classID}/courses/${course?._id}/${
                    fromAssess ? 'assess' : fromPerform ? 'perform' : 'chapters'
                  }?chapter=${chapter?._id}&${courseQueryString}`}
                >
                  {chapter?.name}
                </Link>
              )}
              {quiz?._id && (
                <Typography key="3" color="text.primary">
                  {quiz?.name}
                </Typography>
              )}
              {topic?._id && !subtopic?._id ? (
                <Typography key="3" color="text.primary">
                  {topic?.name}
                </Typography>
              ) : topic?._id ? (
                <Link
                  underline="hover"
                  key="1"
                  color="inherit"
                  href={`/classes/${classID}/courses/${course?._id}/${
                    fromAssess ? 'assess' : fromPerform ? 'perform' : 'chapters'
                  }?topic=${topic?._id}`}
                >
                  {topic?.name}
                </Link>
              ) : null}
              {subtopic?._id && (
                <Typography key="3" color="text.primary">
                  {subtopic?.name}
                </Typography>
              )}
            </Breadcrumbs>
          </Stack>
        </>
      )}
    </>
  );
}

export default memo(DetailsHeader);
